export const PREMIUM_PROMO_SHOP_ID = 843
export const RECENT_PROMO_DAYS = 30

export const PROMO_SCHEDULE_STATUS = {
  active: 'active',
  upcoming: 'upcoming',
  recent: 'recent',
  archived: 'archived',
}

export const PROMO_SCHEDULE_STATUS_LABELS = {
  active: 'Активна',
  upcoming: 'Майбутня',
  recent: 'Недавня',
  archived: 'Архівна',
}

export const PROMO_SCHEDULE_STATUS_SORT_ORDER = {
  active: 0,
  upcoming: 1,
  recent: 2,
  archived: 3,
}

export const DEFAULT_PROMO_SOURCE = 'cashbox'

export const PROMO_TYPE_BRAND_OFFER = 'brandOffer'

export const PROMO_TYPE_VARIANT = {
  brandOffer: 'brandOffer',
  ame: 'ame',
}

export const resolvePromoTypeLabel = (promoType) =>
  promoType === PROMO_TYPE_BRAND_OFFER ? 'Бренд / дистрибютор' : 'Ame'

export const resolvePromoTypeVariant = (promoType) =>
  promoType === PROMO_TYPE_BRAND_OFFER ? PROMO_TYPE_VARIANT.brandOffer : PROMO_TYPE_VARIANT.ame
